import React, { useState, useEffect } from "react";
import { Table, Typography } from "antd";
import NumberFormat from "react-number-format";
import { IDebtService, DebtService } from "../../services/debt-service";
import dayjs from "dayjs";
import { loadAppConfig } from "../../../../config/app-config";
import { useId24 } from "../../../../drivers/id24/Id24-provider";
const appConfig = loadAppConfig();
export interface Props {
  baseURL: string;
  caption: string;
  accountNo: string;
  loading: boolean;
  type: string;
  cifId: string;
  debtContact: any;
}

export const TablePay: React.FC<Props> = ({
  caption,
  accountNo,
  baseURL,
  loading,
  type,
  cifId,
  debtContact,
}): React.ReactElement => {
  const debtService = DebtService;
  const { tokenAccess, login, logout, id24Axios } = useId24();
  const apiBaseUrl = id24Axios(appConfig.apiBaseUrl);
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);

  const [resData, setResData] = useState([]);
  const [typeTable, setTypeTable] = useState<string>("");
  useEffect(() => {
    getDataTable(accountNo);
  }, [accountNo]);

  const getDataTable = async (accountNo: string): Promise<any> => {
    const result = (await debtService(apiBaseUrlDebt).getDebtPayment(
      accountNo
    )) as any;
    // console.log(result?.result[0]);
    const data = (await result?.result?.map(
      (
        x: {
          accountNo: string;
          chn: string;
          trnSeq: string;
          trnCode: string;
          trnDate: string;
          trnTime: string;
          trnAmt: number;
          trnAmtApprove: number;
          endBal: string;
          trnEfDate: string;
          dataDate: string;
          cif: string;
          cusNo: string;
          cardNo: string;
          payFlag: string;
          payChn: string;
          payMethod: string;
          payDesc: string;
          approveTrn: boolean;
          createDate: string;
        },
        index: number
      ) => {
        let aprTxt = "";
        if (x.approveTrn === false) {
          aprTxt = "ไม่อนุมัติ";
        } else {
          aprTxt = "อนุมัติ";
        }

        let date = "";
        if (x.trnDate != null && x.trnDate != "-" && x.trnDate != "") {
          date = dayjs(x.trnDate)
            .locale("th")
            .add(543, "year")
            .format("DD-MM-YYYY");
        }

        let transactionAmountTxt = null;
        if (x.trnAmt) {
          transactionAmountTxt = (
            <NumberFormat
              value={Math.round(x.trnAmt * 100) / 100}
              displayType={"text"}
              decimalScale={2}
              fixedDecimalScale={true}
              thousandSeparator={true}
            />
          );
        }

        let approveAmountTxt = null;
        if (x.trnAmtApprove != 0) {
          approveAmountTxt = (
            <NumberFormat
              value={Math.round(x.trnAmtApprove * 100) / 100}
              displayType={"text"}
              decimalScale={2}
              fixedDecimalScale={true}
              thousandSeparator={true}
            />
          );
        }
        const mapData = {
          key: index,
          accountNo: x.accountNo,
          channel: x.chn,
          date: date,
          transactionCode: x.trnCode,
          transactionAmount: transactionAmountTxt,
          payFlag: x.payFlag,
          payChannel: x.payChn,
          payMethod: x.payMethod,
          payDescription: x.payDesc,
          approveStatus: x.approveTrn,
          approveStatusTxt: aprTxt,
          aproveAmount: approveAmountTxt,
          transactionSeq: x.trnSeq,
        };
        return mapData;
      }
    )) as any;
    setTypeTable(result?.result[0]?.chn);
    setResData(data);
  };
  // console.log(resData);

  const columnsloanod = [
    {
      title: "Channel",
      dataIndex: "channel",
      key: "channel",
      // width: '10%',
    },
    {
      title: "Transaction Date",
      dataIndex: "date",
      key: "date",
      // width: '15%',
    },
    {
      title: "Transaction Code",
      dataIndex: "transactionCode",
      key: "transactionCode",
      // width: '15%',
    },
    {
      title: "Transaction Amount",
      dataIndex: "transactionAmount",
      key: "transactionAmount",
      // width: '20%',
      align: "right" as const,
    },
    {
      title: "Approve Status",
      dataIndex: "approveStatusTxt",
      key: "approveStatusTxt",
      // width: '15%',
    },
    {
      title: "Approve Amount",
      dataIndex: "aproveAmount",
      key: "aproveAmount",
      // width: '15%',
      align: "right" as const,
    },
  ];

  const columnscredit = [
    {
      title: "Channel",
      dataIndex: "channel",
      key: "channel",
      // width: "5%",
    },
    {
      title: "วันที่",
      dataIndex: "date",
      key: "date",
      // width: "6%",
    },
    {
      title: "Transaction Code",
      dataIndex: "transactionCode",
      key: "transactionCode",
      // width: "8%",
    },
    {
      title: "Transaction Amount",
      dataIndex: "transactionAmount",
      key: "transactionAmount",
      // width: "9%",
      align: "right" as const,
    },
    {
      title: "Pay Flag",
      dataIndex: "payFlag",
      key: "payFlag",
      // width: "5%",
    },
    {
      title: "Pay Channel",
      dataIndex: "payChannel",
      key: "payChannel",
      // width: "11%",
    },
    {
      title: "Pay Method",
      dataIndex: "payMethod",
      key: "payMethod",
      // width: "6%",
    },
    {
      title: "Pay Description",
      dataIndex: "payDescription",
      key: "payDescription",
      // width: "10%",
    },
    {
      title: "Approve Status",
      dataIndex: "approveStatusTxt",
      key: "approveStatusTxt",
      // width: "8%",
    },
    {
      title: "Approve Amount",
      dataIndex: "aproveAmount",
      key: "aproveAmount",
      // width: "8%",
      align: "right" as const,
    },
  ];

  return (
    <>
      {typeTable === "LOAN" || typeTable === "OD" ? (
        <Table dataSource={resData} scroll={{ x: "calc(1000px + 50%)" }} />
      ) : (
        <Table
          dataSource={resData}
          columns={columnscredit}
          scroll={{ x: "calc(1500px + 50%)" }}
        />
      )}
    </>
  );
};
